import React from "react";
import PolicyPageTemplate from "../../components/common/PolicyPageTemplate";
import { Shield } from "lucide-react";

const SECTIONS = [
  {
    number: "1",
    title: "Information We Collect",
    body: "We collect information you provide directly, including your name, email address, phone number, postal address, and payment details during account registration and donation processing. We may also collect usage data automatically, such as device type, IP address, app version, and interaction patterns.",
  },
  {
    number: "2",
    title: "How We Use Your Information",
    body: "Your personal data is used solely to: process and confirm donations, send transaction receipts and tax certificates, communicate important updates about causes you support, personalise your in-app experience, and comply with legal and regulatory obligations. We do not use your data for unrelated commercial purposes.",
  },
  {
    number: "3",
    title: "Data Sharing & Third Parties",
    body: "We do not sell, trade, or rent your personal information to third parties. We may share data with trusted service providers — such as payment processors and cloud storage vendors — strictly to operate the platform. All third-party partners are contractually bound to protect your data under equivalent standards.",
  },
  {
    number: "4",
    title: "Cookies & Tracking",
    body: "Our application may use session tokens and analytics tools to improve performance and user experience. These do not store personally identifiable information. You may opt out of analytics tracking in the application settings at any time.",
  },
  {
    number: "5",
    title: "Data Retention",
    body: "We retain your personal information for as long as your account is active or as required to fulfil our legal obligations. Upon account deletion, your data will be permanently removed within 30 days, except where retention is required by law (e.g. financial records).",
  },
  {
    number: "6",
    title: "Data Security",
    body: "We implement industry-standard security measures including SSL/TLS encryption, secure data centres, and regular security audits to safeguard your information. However, no method of electronic transmission is 100% secure. We encourage you to use a strong, unique password for your account.",
  },
  {
    number: "7",
    title: "Your Rights",
    body: "You have the right to access, correct, or delete your personal data at any time. You may also request a copy of all data we hold about you. To exercise these rights, contact us at privacy@aafsa.org. We will respond to all valid requests within 30 days.",
  },
  {
    number: "8",
    title: "Children's Privacy",
    body: "AAFSA does not knowingly collect personal information from individuals under the age of 18. If you believe a minor has provided us with personal data, please contact us immediately so we can take appropriate action to remove it.",
  },
  {
    number: "9",
    title: "Changes to this Policy",
    body: "We may update this Privacy Policy from time to time. Any significant changes will be communicated via in-app notification or email. We encourage you to review this policy periodically to stay informed about how we protect your data.",
  },
  {
    number: "10",
    title: "Contact & Complaints",
    body: "If you have any privacy-related questions, concerns, or complaints, please contact our Data Protection Officer at privacy@aafsa.org. You also have the right to lodge a complaint with the relevant data protection authority in your jurisdiction.",
  },
];

const PrivacyPolicy = () => {
  return (
    <PolicyPageTemplate
      title="Privacy Policy"
      subtitle="Your privacy is critically important to us. Learn how we handle, process, and safeguard your personal data across all AAFSA platforms."
      dateLabel="LAST UPDATED"
      dateValue="1 January 2025"
      contactEmail="privacy@aafsa.org"
      contactRole="Data Protection Officer"
      intro="Your privacy is critically important to us. We adhere to strict data protection principles to ensure your personal information is kept secure, used responsibly, and never shared without your consent."
      sections={SECTIONS}
      policyIcon={Shield}
    />
  );
};

export default PrivacyPolicy;
